// Shared formatter for builder + multisite views — keeps numerals consistent
// with the existing KpiCard while being lighter weight (no JSX).
export const formatMetric = (value, format) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  if (format === 'currency') {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      maximumFractionDigits: value >= 10000 ? 0 : 2,
    }).format(value);
  }
  if (format === 'percent') return `${Number(value).toFixed(1)}%`;
  if (format === 'int') return new Intl.NumberFormat('en-GB').format(Math.round(value));
  return String(value);
};

export const RANGE_LABELS = {
  today: 'Today', yesterday: 'Yesterday',
  wtd: 'Week to date', last_week: 'Last week',
  mtd: 'Month to date', last_month: 'Last month', last_quarter: 'Last quarter',
  ytd: 'Year to date',
  last_7: 'Last 7 days', last_30: 'Last 30 days', last_60: 'Last 60 days', last_90: 'Last 90 days',
  last_12_weeks: 'Last 12 weeks',
};

export const formatRange = (k) => RANGE_LABELS[k] || k;
